
































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Inairthreshold from "../../../store/entities/inairthreshold";
@Component
export default class CreateInairthreshold extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  inairthreshold: Inairthreshold = new Inairthreshold();
  idisable:boolean = false;
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  save() {
    (this.$refs.inairthresholdForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.idisable = true;
        await this.$store.dispatch({
          type: "inairthreshold/create",
          data:this.inairthreshold
        });
        (this.$refs.inairthresholdForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
         setTimeout(()=>{
           this.idisable=false   //点击一次时隔两秒后才能再次点击
       },2000)
      }
    });
  }
  cancel(){
            (this.$refs.inairthresholdForm as any).resetFields();
            this.$emit('input',false);
        }
  inairthresholdRule = {
    tName: [{ required: true, message: "请填写阈值方案名称", trigger: "blur" }],
    MAXPM10: [{required: true, message: "请填写PM10最大值", trigger: "blur" }],
    MAXPM25: [{required: true, message: "请填写PM2.5最大值", trigger: "blur" }],
  };
}
